<div class="row py-2 my-3">
  <div class="col">
    <ul class="list-group">
      @for (step of progressSteps; track step.id) {
        <li
          class="d-flex align-items-center gap-1 list-group-item position-relative"
          [ngClass]="{
            'text-body-secondary': step.status === 'idle',
            'text-success': step.status === 'succeeded',
            'text-danger': step.status === 'failed'
          }"
        >
          @if (step.status === 'running') {
            <div class="progress progress-absolute" [style.opacity]="0.25">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated bg-info w-100"
                role="progressbar"
              ></div>
            </div>
          }
          <span class="d-inline-flex flex-fill align-items-center justify-content-between">
            <span style="z-index: 10" class="d-flex align-items-center gap-1">
              @if (step.status === 'idle') {
                <i class="bi bi-slash-circle preload text-secondary me-1"></i>
              }
              @if (step.status === 'running') {
                <i class="bi bi-play-circle-fill preload text-primary me-1"></i>
              }
              @if (step.status === 'succeeded') {
                <i class="bi bi-check-circle-fill preload text-success me-1"></i>
              }
              @if (step.status === 'failed') {
                <i class="bi bi-x-circle-fill preload text-danger me-1"></i>
              }
              <span
                >{{ step.label }}
                @if (step.error) {
                  <div class="text-body-secondary small">{{ step.error }}</div>
                }
              </span>
            </span>
            <span class="d-inline-flex align-items-center gap-4">
              @if (step.status !== 'running' && step.value !== undefined) {
                <span class="text-end">{{ step.value }}</span>
              }
              <span appMotionPreventedTooltip>
                @if (showActions) {
                  <button [disabled]="disabled || isRunning" (click)="run.emit(step)" class="btn btn-sm btn-secondary">
                    RUN
                  </button>
                }
              </span>
            </span>
          </span>
        </li>
      }
    </ul>
  </div>
</div>

<ng-template #actionButton let-step>
  @switch (step.state === 'running') {}
</ng-template>
